export default __webpack_public_path__ + "static/media/3886.de95850d.png";